<template>
  <div class="form-group">
    <label v-if="title">
      <span class="title">{{ title }}</span>
      <span class="required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>
    <div class="inner-addon right-addon">
      <i v-if="notifications.length > 0 && formDirty" class="required glyphicon fas fa-exclamation-triangle"></i>
      <slot v-else></slot>
      <input :style="_style" class="form-control" type="text" inputmode="decimal" :placeholder="placeholder"
        :disabled="disabled" :value="valueLocal" @input="onInput" @blur="onBlur"
        @keyup.enter.prevent="pressedEnter" />
    </div>

    <div v-if="formDirty">
      <div v-for="message in notifications" :key="message">
        <span class="invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";

import { mapState, mapMutations } from "vuex";

export default {
  name: "InputNumber",
  components: { Tip },
  props: {
    title: String,
    field: String,
    _style: String,
    placeholder: String,
    disabled: Boolean,
    formName: String,
    required: Boolean,
    maxLength: Number,
    type: {
      type: String,
      default: "float",
    },
    markFormDirty: {
      type: Boolean,
      default: true,
    },
    params: Object,
    value: Number,
    changed: Function,
    enter: Function,
  },
  data() {
    return {
      notifications: [],
      formDirty: false,
      valueLocal: "",
    };
  },
  created() {
    this.valueLocal = this.format(this.value);
  },

  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    format(value) {
      if (value === null || value === undefined || value === "") return "";
      if (isNaN(value)) return "";
      if (this.type === "int") return String(value);
      return String(value).replace(".", ",");
    },
    sanitize(text) {
      let clean = String(text).replace(/[^0-9,.-]/g, "");
      let isNegative = clean.indexOf("-") === 0;
      clean = clean.replace(/-/g, "");

      if (this.type === "int") {
        clean = clean.split(/[,.]/)[0];
      } else {
        clean = clean.replace(/\./g, ",");
        let parts = clean.split(",");
        if (parts.length > 1) clean = parts.shift() + "," + parts.join("");
      }

      return isNegative ? "-" + clean : clean;
    },
    parse(text) {
      if (text === "" || text === "-" || text === "," || text === "-,") return null;
      let parsed =
        this.type === "int"
          ? parseInt(text, 10)
          : parseFloat(String(text).replace(",", "."));
      return isNaN(parsed) ? null : parsed;
    },
    onInput(event) {
      let clean = this.sanitize(event.target.value);
      if (event.target.value !== clean) event.target.value = clean;
      this.valueLocal = clean;
    },
    onBlur() {
      this.valueLocal = this.format(this.parse(this.valueLocal));
    },
    validate() {
      this.notifications = [];
      let parsed = this.parse(this.valueLocal);

      if (this.required && parsed === null) {
        let message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }

      if (parsed !== null && this.maxLength) {
        let integerLength = Math.trunc(Math.abs(parsed)).toString().length;
        if (integerLength > this.maxLength) {
          let message = `Valor inválido!`;
          this.notifications.push(message);
        }
      }
    },
    pressedEnter() {
      if (this.enter) this.enter(this.params);
    },
  },
  computed: {
    ...mapState("validation", ["resetForm"]),
  },
  watch: {
    value(newValue) {
      if (this.parse(this.valueLocal) !== newValue)
        this.valueLocal = this.format(newValue);
      if (this.changed) this.changed();
    },
    valueLocal() {
      this.validate();
      this.$emit("input", this.parse(this.valueLocal));
      this.formDirty = true;
      if (this.markFormDirty) this.updateFormDirty(true);
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) this.formDirty = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #0a0a0a;
  letter-spacing: 0.5px !important;
}

.success {
  color: #94aa2a;
  font-size: 14px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}

.margin-button {
  margin-top: -2px;
}
</style>
